import { SystemOptionType } from 'data/types';
import { ductedHeadlineCoveragePercentsForSystem } from './ducted-performance-display';
import { combinedCoverage, SystemSortMetrics } from './system-sort';

const finiteOrNull = (value: number | null | undefined): number | null =>
  typeof value === 'number' && Number.isFinite(value) ? value : null;

export function systemOptionSortMetrics(
  system: SystemOptionType
): SystemSortMetrics {
  const ducted = ductedHeadlineCoveragePercentsForSystem(system);
  const heating = ducted ? ducted.heating : finiteOrNull(system.heatingScore);
  const cooling = ducted ? ducted.cooling : finiteOrNull(system.coolingScore);
  return {
    price: finiteOrNull(system.price),
    operatingCost: finiteOrNull(system.totalAnnualCost),
    // A ducted-only figure; the ductless gallery never offers that sort.
    costOfOwnership: null,
    heating,
    cooling,
    heatingCooling: combinedCoverage(heating, cooling)
  };
}
